import { Navigate, useNavigate } from "@tanstack/react-router";
import { useState, type FormEvent } from "react";
import { useAuth } from "@/app/auth";
import { Alert, Button, Field, Input, Spinner } from "@/components/ui";
import { supabase } from "@/lib/supabase";

/** Definir senha: primeiro acesso por convite ou recuperação de senha. */
export function SetPasswordPage() {
  const { status, clearNeedsPassword } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (status === "loading") return <Spinner />;
  if (status === "signed_out") return <Navigate to="/login" />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (password.length < 10) return setError("A senha precisa ter pelo menos 10 caracteres.");
    if (password !== confirm) return setError("As senhas não conferem.");
    setBusy(true);
    const { error: err } = await supabase!.auth.updateUser({ password });
    setBusy(false);
    if (err) return setError("Não foi possível salvar a senha. Tente outra senha.");
    clearNeedsPassword();
    await navigate({ to: "/" });
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/50 px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-4 rounded-lg border bg-card p-6 shadow-sm"
      >
        <h1 className="text-xl font-semibold">Defina sua senha</h1>
        {error && <Alert tone="error">{error}</Alert>}
        <Field label="Nova senha" hint="Mínimo de 10 caracteres.">
          <Input
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>
        <Field label="Repita a senha">
          <Input
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
        </Field>
        <Button type="submit" className="w-full" disabled={busy}>
          Salvar senha
        </Button>
      </form>
    </div>
  );
}
